import React, {useMemo, useState} from 'react'
import DashboardPanel from "./DashboardPanel";
import ScrollArea from "react-scrollbar";
import EmptyBanner from "../../../components/EmptyBanner";
import {Link} from "react-router-dom";
import TalentPortal from "../../talent-portal/TalentPortal";
import LoadingSpinner from "../../../components/LoadingSpinner";
import Opportunity from "../../../models/Opportunity";
import { Badge } from "antd";

import {useAuth} from "../../../providers/AuthProvider";

const OpportunityListView = ({opportunities}) => {
    const {auth} = useAuth();

    const [activeTab, setActiveTab] = useState("All");
    let statusOptions = Opportunity.statusOptions();
    delete statusOptions['Lost/Declined']

    const tabs = useMemo(() => {

        let opps = TB.map(Opportunity.makeMany(opportunities || []), opportunity => {
            opportunity.display_status = opportunity.displayStatus();
            opportunity.last_updated = opportunity.lastUpdated();
            return opportunity;
        });
        opps = TB.orderBy(opps, 'last_updated', 'desc')

        let statusOptions = Opportunity.statusOptions();
        delete statusOptions['Lost/Declined']
        let groupedOpps = TB.groupBy(opps, 'display_status');

        return TB.reduce(statusOptions, (result, status)=> {
            result[status] = groupedOpps[status] || [];
            return result
        }, {'All': opps});
    }, [opportunities, activeTab]);



    const visibleOpps = tabs[activeTab] || [];

    return (
        <div className="talent-panel-content-container">

            <div className="opportunity-list">
                <div className="opportunity-list-section">
                    <div className="opportunity-status-row">
                        {TB.keys(tabs).map(status => (
                                <button
                                    key={status}
                                    onClick={() => setActiveTab(status)}
                                    className={
                                        TB.mapClass({
                                            "opportunity-status-tab": true,
                                            'active': status === activeTab
                                        })
                                    }>
                                    {status}
                                </button>
                            )
                        )}
                    </div>

                    <div className="opportunity-list-items">
                        <ScrollArea
                            speed={0.8}
                            className="area"
                            smoothScrolling={false}
                            contentClassName="scroll-area"
                            stopScrollPropagation={true}
                            horizontal={false}>

                            {visibleOpps.length > 0 ? visibleOpps.map(opportunity => (

                                <div key={`opp-${opportunity.id}`}
                                     className="opportunity-list-item"
                                     style={{
                                         opacity: !opportunity.isAvailable() ? 0.6 : 1,
                                         pointerEvents: !opportunity.isAvailable() ? 'none': 'unset'
                                     }}
                                >
                                    <Link to={opportunity.detailLink()}
                                          className="mb-1 opportunity-detail text-dark text-bold text-underline">

                                        {opportunity.hasUnseenUpdate() && (
                                            <span className="mr-1 inline-block py-px px-1.5 h-[13px] bg-danger rounded-xl text-white text-[8px]">UPDATED!</span>
                                        )}
                                        {opportunity.project.name}
                                    </Link>

                                    <div className="opp-item-details">
                                        <div className="opp-item-info">
                                            <p className="mb-0">
                                                Status: <span className="text-underline text-bold text-italic"
                                                              style={{color: opportunity.statusColor()}}>
                                                {opportunity.display_status}
                                            </span>
                                            </p>
                                            {opportunity.last_updated && (
                                                <p className="mb-0">
                                                    Updated: <span><strong><i>{TB.moment(opportunity.last_updated).fromNow()}</i></strong></span>
                                                </p>
                                            )}
                                        </div>

                                        {opportunity.canMessageAndAcceptInterviews() && (
                                            <div className="opp-links">
                                                {auth.canViewTalentOppMessages() && (
                                                    <Link className="btn btn-link btn-link-info" to={{
                                                        pathname: opportunity.proposalLink(),
                                                        search: `?tabView=messages`
                                                    }}>
                                                        <span className="text-secondary">
                                                            {!!opportunity.unread_messages_count && (
                                                                <Badge count={opportunity.unread_messages_count} size="small" className="mr-1" />
                                                            )}
                                                        </span>
                                                        <span>
                                                            Messages
                                                        </span>
                                                    </Link>
                                                )}


                                                {auth.canViewTalentOppInterviews() && (
                                                    <Link className="btn btn-link btn-link-info" to={{
                                                        pathname: opportunity.proposalLink(),
                                                        search: `?tabView=interviews`
                                                    }}>
                                                        <span className="text-secondary">
                                                            {!!opportunity.proposed_meetings_count && (
                                                                <Badge count={opportunity.proposed_meetings_count} size="small" className="mr-1" />
                                                            )}
                                                        </span>
                                                        <span>
                                                            Interviews
                                                        </span>
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )) : (
                                <EmptyBanner message={`No Projects ${activeTab} Yet`}/>
                            )}
                        </ScrollArea>
                    </div>
                </div>
            </div>
            <div className="flex mt-2 justify-end">
                <Link to={TalentPortal.projectsListPath()} className="btn btn-primary">
                    View All Projects
                </Link>
            </div>
        </div>
    )
}

export default class ProjectPanel extends DashboardPanel {

    static header = 'talent.dashboard.project_title';

    static is_active = true;
    static inactiveMessage = `Manage your ${laravel.platform_name} projects from opportunity notification all the way to completion.`;

    static columns = 'auto';
    static colClass= 'order-5 mb-6 w-full sm:px-3';

    static columnProps = {
        xl: 4,
        lg: 6,
        md: 6,
        sm: 12,
        xs: 12
    }

    static columnOrdering = {
        xl: 5,
        lg: 5,
        md: 5,
        sm: 5,
        xs: 5
    }

    constructor(props) {
        super(props);

        this.state = {
            activeStatus: undefined
        }
    }

    isDisabled() {
        return !this.context?.auth?.isProfileApproved()
    }

    toggleStatus = (activeStatus) => {
        return this.setState({activeStatus})
    }

    daysSinceUpdated()
    {
        let {lastViewed} = this.props;
        if (!lastViewed) {
            return;
        }

        let days = TB.moment(lastViewed).diff(TB.moment(), 'days');
        if (days < 0) days = 0;

        return days;
    }

    renderPanelContent()
    {
        let {opportunities} = this.props;
        if (!opportunities) {
            return (
                <div className="flex flex-col items-center justify-center flex-grow">
                    <LoadingSpinner size="lg"/>
                </div>
            )
        }

        return <OpportunityListView opportunities={opportunities}/>
    }
}